import { render, staticRenderFns } from "./OnFss.vue?vue&type=template&id=5b705774&"
import script from "./OnFss.vue?vue&type=script&lang=js&"
export * from "./OnFss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports